import React from 'react';
import FeedContainerSmall from '../NewsFeed/FeedContainerSmall';

const BroadcastAreaFeed = ({contentContainers}) => (

  <div className="broadcastarea-feed">
    {
      contentContainers && contentContainers.map((contentContainer) => <FeedContainerSmall key={contentContainer.id} contentContainer={contentContainer} />)
    }
 </div>
);

BroadcastAreaFeed.propTypes = {
  contentContainers: React.PropTypes.array,
};

export default BroadcastAreaFeed;



// WEBPACK FOOTER //
// ./src/component/Sidebar/BroadcastAreaFeed.jsx